var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 49,
    viewBox: "0 0 96 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.5773,
    cy: 7.28342,
    rx: 6.92496,
    ry: 6.78342,
    fill: "#FF0000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8869 26.1581C22.2148 25.3471 23.3629 25.3471 23.6907 26.1581L31.8162 46.2576C32.1446 47.0701 33.2957 47.0681 33.6212 46.2544L44.6297 18.7448C44.8854 18.1058 44.4148 17.4105 43.7265 17.4105H40.607C40.2093 17.4105 39.8516 17.6527 39.7038 18.0219L33.6213 33.2217C33.2957 34.0353 32.1446 34.0373 31.8162 33.2248L25.669 18.0188C25.5204 17.6512 25.1636 17.4105 24.7671 17.4105H20.8106C20.4141 17.4105 20.0573 17.6512 19.9087 18.0188L13.7613 33.2248C13.4328 34.0373 12.2818 34.0353 11.9562 33.2216L5.87388 18.0219C5.72611 17.6527 5.36843 17.4105 4.97069 17.4105H1.85116C1.16287 17.4105 0.692256 18.1058 0.947968 18.7448L11.9562 46.2545C12.2818 47.0681 13.4328 47.0701 13.7613 46.2576L21.8869 26.1581Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.5236 20.7154C65.264 21.355 65.7347 22.054 66.425 22.054H76.0976C76.6349 22.054 77.0704 21.6184 77.0704 21.0811V18.3812C77.0704 17.8439 76.6349 17.4084 76.0976 17.4084H74.8302H67.5204C67.1244 17.4084 66.7679 17.6485 66.619 18.0155L65.5236 20.7154Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.4825 33.2296C60.2254 33.8689 60.6961 34.5654 61.3851 34.5654H76.041C76.5782 34.5654 77.0138 34.1299 77.0138 33.5926V30.8927C77.0138 30.3554 76.5782 29.9199 76.041 29.9199H73.7016H62.4708C62.0737 29.9199 61.7164 30.1613 61.5683 30.5297L60.4825 33.2296Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.5529 45.5079C55.2933 46.1475 55.764 46.8464 56.4543 46.8464H76.0426C76.5799 46.8464 77.0155 46.4109 77.0155 45.8736V43.1737C77.0155 42.6364 76.5799 42.2009 76.0426 42.2009H73.7032H57.5497C57.1537 42.2009 56.7972 42.441 56.6483 42.808L55.5529 45.5079Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.9786 20.7154C46.7191 21.355 47.1898 22.054 47.8801 22.054H61.1709C61.563 22.054 61.9168 21.8186 62.0682 21.4569L63.199 18.757C63.4675 18.116 62.9967 17.4084 62.3017 17.4084H56.0617H48.9755C48.5795 17.4084 48.223 17.6485 48.0741 18.0154L46.9786 20.7154Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.0336 33.3558C41.7829 33.994 42.2534 34.6843 42.9391 34.6843H56.1722C56.5714 34.6843 56.93 34.4405 57.0769 34.0694L58.192 31.2503C58.4446 30.6118 57.9741 29.9197 57.2874 29.9197H51.0711H44.0465C43.6465 29.9197 43.2873 30.1645 43.141 30.5368L42.0336 33.3558Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.1653 45.5222C36.9183 46.1598 37.3887 46.8464 38.0724 46.8464H51.3129C51.712 46.8464 52.0707 46.6026 52.2175 46.2315L53.3326 43.4124C53.5852 42.7739 53.1147 42.0818 52.428 42.0818H46.078H39.1643C38.7627 42.0818 38.4023 42.3286 38.2572 42.7032L37.1653 45.5222Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.8407 46.0714C51.3452 46.5208 52.1527 46.3287 52.4061 45.6989L57.2495 33.6574C57.4001 33.2832 57.3027 32.858 57.0048 32.5889L54.7083 30.514C54.2048 30.0592 53.3923 30.2496 53.1379 30.882L50.8126 36.6629L48.2858 42.9449C48.1343 43.3215 48.2339 43.7493 48.5356 44.018L50.8407 46.0714Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M80.308 18.3974C80.308 17.8602 80.744 17.4216 81.2804 17.4533C85.0536 17.6764 88.6252 19.1919 91.3141 21.7333C94.2332 24.4922 95.873 28.234 95.873 32.1355C95.873 36.0371 94.2332 39.7789 91.3141 42.5377C88.6252 45.0791 85.0536 46.5946 81.2804 46.8177C80.744 46.8494 80.308 46.4109 80.308 45.8736L80.308 43.2136C80.308 42.6764 80.7444 42.2452 81.2797 42.199C83.759 41.9853 86.0936 40.9585 87.8684 39.2811C89.8735 37.3859 91 34.8156 91 32.1355C91 29.4554 89.8736 26.8851 87.8684 24.99C86.0936 23.3126 83.759 22.2858 81.2797 22.072C80.7444 22.0259 80.308 21.5947 80.308 21.0574L80.308 18.3974Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.79e6c72e0f3aca928453632391b6f332.svg";
export { ForwardRef as ReactComponent };